export default "__VITE_ASSET__CUZuK64C__"